import type { FC, ReactElement } from 'react'
import type { FlexProps, StackProps } from '@chakra-ui/react'
import { VStack } from '@chakra-ui/react'
import { type TopNavPanelItem } from 'ecosystem'
import Panel from './Panel'
import type { TopNavContentProps } from './TopNavContent'
import TopNavContent from './TopNavContent'

type ITopNav = StackProps &
  TopNavContentProps & {
    panelItems?: TopNavPanelItem[]
    logo: ReactElement
    panelHeight?: FlexProps['h']
    contentHeight: FlexProps['h']
    // Dropdown category menu is hidden
    isHidden: boolean
    contentContainerProps?: FlexProps
  }

const TopNav: FC<ITopNav> = ({
  panelItems,
  navbarActions,
  menuItems,
  logo,
  panelHeight,
  contentHeight,
  isHidden,
  onMenuToggle,
  toggleIcon,
  onMenuHover,
  contentContainerProps,
  ...props
}) => {
  const isMenuOpened = !isHidden

  return (
    <VStack position="fixed" spacing={0} w="100%" zIndex={9000} {...props}>
      {panelItems ? (
        <Panel h={panelHeight ?? 'auto'} transition="all 0.25s ease" {...{ panelItems }} />
      ) : null}
      <TopNavContent
        bg={
          isMenuOpened
            ? 'var(--chakra-colors-component-TopNavContent-root-_menuIsOpened-background,var(--chakra-colors-background-default))'
            : 'var(--chakra-colors-component-TopNavContent-root-background,var(--chakra-colors-background-translucent))'
        }
        h={contentHeight}
        transition="all 0.25s ease"
        {...contentContainerProps}
        {...{
          isHidden,
          menuItems,
          navbarActions,
          logo,
          onMenuToggle,
          toggleIcon,
          onMenuHover
        }}
      />
    </VStack>
  )
}

export default TopNav
